import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "itemCount", "totalQty", "componentTotals", "grandTotal", "itemTotal"]
  static values = { currencySymbol: String }

  connect() {
    this.calculate()

    // Watch for changes in the container
    this.observer = new MutationObserver(() => this.calculate())
    if (this.hasContainerTarget) {
      this.observer.observe(this.containerTarget, { childList: true, subtree: true })
    }

    // Listen for input changes
    this.element.addEventListener('input', this.calculate.bind(this))
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  calculate() {
    const items = this.containerTarget.querySelectorAll('.supply-item')
    let visibleCount = 0
    let totalQty = 0
    let grandTotal = 0
    const componentTotals = {}

    items.forEach(item => {
      // Skip destroyed items
      const destroyInput = item.querySelector('input[name*="_destroy"]')
      if (destroyInput && destroyInput.value === '1') return
      if (item.style.display === 'none') return

      visibleCount++

      // Get quantity
      const qtyInput = item.querySelector('input[name*="[quantity]"]')
      if (qtyInput) {
        totalQty += parseInt(qtyInput.value) || 0
      }

      // Get total cost
      const totalInput = item.querySelector('[data-supply-item-pricing-target="totalCost"]')
      if (totalInput) {
        grandTotal += parseFloat(totalInput.value) || 0
      }

      // Get component values
      const componentInputs = item.querySelectorAll('[data-component-id]')
      componentInputs.forEach(input => {
        const componentId = input.dataset.componentId
        const value = parseFloat(input.value) || 0
        const qty = parseInt(qtyInput?.value) || 0
        componentTotals[componentId] = (componentTotals[componentId] || 0) + (value * qty)
      })
    })

    // Update displays
    if (this.hasItemCountTarget) {
      this.itemCountTarget.textContent = visibleCount
    }

    if (this.hasTotalQtyTarget) {
      this.totalQtyTarget.textContent = totalQty
    }

    if (this.hasGrandTotalTarget) {
      this.grandTotalTarget.value = grandTotal.toFixed(2)
    }

    // Update component totals
    if (this.hasComponentTotalsTarget) {
      const totalElements = this.componentTotalsTarget.querySelectorAll('[data-component-total]')
      const symbol = this.hasCurrencySymbolValue ? this.currencySymbolValue : ''
      totalElements.forEach(el => {
        const componentId = el.dataset.componentTotal
        const total = componentTotals[componentId] || 0
        el.textContent = `${symbol}${total.toFixed(2)}`
      })
    }
  }
}
